import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Home from '../screens/NowPlaying/Home';
import MyList from '../screens/MyList/MyList';
import Account from '../screens/Account/Account';

const Router = () => {
    return (
        <Switch>
            <Route path='/mylist' component={MyList} />
            <Route path='/account' component={Account} />
            <Route path='/' component={Home} />
            <Route render={() => <Redirect to='/' />} />
        </Switch>
    );
};

export default Router;
